/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/291' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/device/list`
 */
export interface StationDeviceListGetRequest {
  /**
   * 设备名称
   */
  deviceName?: string;
  /**
   * 页码 默认1
   */
  page?: string;
  /**
   * 每页条数 默认10
   */
  size?: string;
  /**
   * 1 站 2 桩 3 枪
   */
  level: number;
}

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/device/list`
 */
export interface StationDeviceListGetResponse {
  page?: number;
  size?: number;
  total?: number;
  list?: {
    /**
     * 设备id
     */
    deviceId?: number;
    /**
     * 设备名称
     */
    deviceName?: string;
    /**
     * 组织名称
     */
    customerName?: string;
    /**
     * 类目名称
     */
    deviceType?: string;
    /**
     * 是否绑定
     */
    bind?: boolean;
  }[];
}

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/device/list`
 */
type ApiStationDeviceListGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/291',
    '',
    'http://127.0.0.1',
    '/api/station/device/list',
    'retdata',
    string,
    'deviceName' | 'page' | 'size' | 'level',
    false
  >
>;

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/device/list`
 */
const apiStationDeviceListGetRequestConfig: ApiStationDeviceListGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/station/device/list',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['deviceName', 'page', 'size', 'level'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiStationDeviceListGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/device/list`
 */
export const apiStationDeviceListGet = /*#__PURE__*/ (
  requestData: StationDeviceListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<StationDeviceListGetResponse>(prepare(apiStationDeviceListGetRequestConfig, requestData), ...args);
};

apiStationDeviceListGet.requestConfig = apiStationDeviceListGetRequestConfig;

/* prettier-ignore-end */
